export { View as PersonalFooterIpoteka } from './view'
